// extracted by mini-css-extract-plugin
module.exports =  {"button":"AddGasButton-module_button_ef30d","alignButton":"AddGasButton-module_alignButton_d4e50"};